export type LikelihoodLevel = "High" | "Moderate" | "Low";

export const LIKELIHOOD_LEVELS = {
  LOW: {
    level: "Low" as LikelihoodLevel,
    color: "#565EFA",
    description: "Returns may differ significantly from predictions.",
    recommendation:
      "This scenario carries a high degree of uncertainty. We recommend you approach it with caution and explore other options or adjust some channels.",
  },
  MODERATE: {
    level: "Moderate" as LikelihoodLevel,
    color: "#FC9429",
    description: "Returns may differ somewhat from predictions.",
    recommendation:
      "This scenario offers the potential for greater returns with some risk. We recommend exploring adjustments to see if the potential growth is worth it.",
  },
  HIGH: {
    level: "High" as LikelihoodLevel,
    color: "#09A856",
    description: "Returns are expected to align with predictions.",
    recommendation:
      "This scenario is a safe and reliable option, aligning closely with past trends and our model's expectations. This is a solid plan to implement.",
  },
};

export const getLikelihoodLevel = (percentage: number) => {
  if (percentage >= 80) return LIKELIHOOD_LEVELS.HIGH;
  if (percentage >= 50) return LIKELIHOOD_LEVELS.MODERATE;
  return LIKELIHOOD_LEVELS.LOW;
};
